<template>
  <div>
    <v-toolbar
      flat
      class="elevation-1"
    >
      <v-toolbar-title>Notificaciones</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        label="Buscar"
        single-line
        hide-details
        v-model="filtros.search"
        v-on:keyup.enter="filtrar"
      >
      </v-text-field>
      <v-btn
        color="secondary"
        fab
        small
        @click="filtrar()"
      >
        <v-icon class="primary--text">search</v-icon>
      </v-btn>

    </v-toolbar>
    <v-data-table
      must-sort
      :headers="headers"
      :items="items"
      :pagination.sync="paginacion"
      :total-items="totalItems"
      :rows-per-page-items="itemsPorPagina"
      :loading="cargando"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
        v-if="cargando"
      ></v-progress-linear>
      <template v-slot:items="props">
        <td class="text-xs-center pa1">{{ props.item.id }}</td>
        <td class="text-xs-left pa1">{{ props.item.created_at | formatoFecha }}</td>
        <td class="text-xs-left pa1">{{ props.item.institucion | nombreCentro }}</td>
        <td
          class="text-xs-left pa1"
          v-html="props.item.notificacion"
        ></td>
        <td
          class="text-xs-left pa1"
          v-if="props.item.fecha_resolucion === null"
        >
          <v-chip
            small
            class="error white--text"
          >Pendiente</v-chip>
        </td>
        <td
          class="text-xs-left pa1"
          v-else
        >
          <v-chip
            small
            class="success white--text"
          >Realizada</v-chip>
        </td>
        <td class="text-xs-left pa1">{{ props.item.usuario ? props.item.usuario.persona.nombre + ' ' + props.item.usuario.persona.apellido : '--' }}</td>
        <td
          class="text-xs-left pa1"
          v-if="props.item.fecha_resolucion !== null"
        >{{props.item.fecha_resolucion  | formatoFecha }}</td>
        <td
          class="text-xs-left pa1"
          v-else
        >--</td>
        <td class="justify-center layout ">
          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-0"
            v-if="puedo('lectura') || puedo('modif')"
            @click="finalizar(props.item)"
            :class="props.item.fecha_resolucion === null ? '' : 'd-none'"
          >
            <v-icon small>check</v-icon>
          </v-btn>

          <v-btn
            icon
            flat
            small
            color="blue-grey"
            class="mx-1"
            v-if="puedo('baja')"
            @click="eliminar(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>

import abmListadoMixin from '@/mixins/abmListado'
import { formatoFecha } from '@/helpers/filtros'
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: 'NotificacionesAbmListado',
  mixins: [abmListadoMixin],
  filters: {
    formatoFecha
  },
  data: () => ({
    headers: [
      {
        text: 'ID',
        align: 'center',
        value: 'id'
      },
      { text: 'Fecha', value: 'created_at' },
      { text: 'Institución', value: 'institucion', sortable: false },
      { text: 'Notificación', value: 'notificacion', sortable: false },
      { text: 'Estado', value: 'estado', sortable: false },
      { text: 'Usuario', value: 'usuario', sortable: false },
      { text: 'Fecha realización', value: 'fecha_realizacion', sortable: false },
      { text: '', value: 'name', sortable: false, align: 'center' }
    ],
    paginacion: { 'descending': true, 'sortBy': 'id' }
  }),
  computed: {
    usuario () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    filtrarDatos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'
      _filtros.usuario_id = this.usuario.id

      vm.cargando = true
      vm.modeloApi.filtrar(_filtros).then(
        data => {
          vm.items.lenght = 0
          vm.items = data.data
          vm.totalItems = data.total
          vm.cargando = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },
    finalizar (item) {
      let vm = this
      let _params = {}

      _params.usuarioId = this.usuario.id

      vm.cargando = true
      vm.modeloApi
        .finalizar(item.id, _params)
        .then(() => {
          Vue.notify({
            group: 'general',
            type: 'success',
            text: 'La operación finalizó correctamente!'
          })
          vm.cargando = false
          vm.filtrar()
        })
        .catch(error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        })
    }
  }
}
</script>
